import React from 'react'
import "../../App.css"
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const {t} = useTranslation();
  return (
    <div>
      <div className='footer'>
        <div className='footerplus'>
        <div style={{marginBottom: '20px'}}> <a href='/'>{t("footer.a2")}</a> | <a href='/'> {t("footer.a1")}  </a></div>
          <div> <b>{t("footer.span1")}</b></div>
          <div><b>{t("footer.b6")}</b> <span>{t("footer.span3")}</span></div>
          <div> <b>{t("footer.b2")}</b> <span>{t("footer.span2")}</span></div>
          <div> <b>{t("footer.b3")}</b> <span>213-07-24214</span> </div>
          <div><b>{t("footer.b4")}</b> <span>{t("footer.span3")}</span></div>
          <div><b>{t("footer.b5")}</b> <span>service@shareplug.co.kr</span></div>
          <div> <b></b>  <span>©️2022 RainCircle. All rights reserved.</span></div>
        </div>
      </div>
    </div>
  )
}

export default Footer
 